import { IPaymentActions } from '../../../models'
import {
  ConfirmStepTypeKeys,
  IConfirmNewReservationAction,
  IConfirmNewReservationFailedAction,
  IConfirmNewReservationSuccessfulAction,
  ISetIsConfirmingNewReservationAction,
} from '../../types'

export function confirmNewReservationAction(payOption?: IPaymentActions, activePassId?: number): IConfirmNewReservationAction {
  return { type: ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION, payload: { payOption: payOption!, activePassId } }
}

export function setIsConfirmingNewReservationAction(): ISetIsConfirmingNewReservationAction {
  return { type: ConfirmStepTypeKeys.CONFIRMING_NEW_RESERVATION }
}

export function confirmNewReservationSuccessfulAction(userCreatedFlag: boolean): IConfirmNewReservationSuccessfulAction {
  return { type: ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION_SUCCESSFUL, payload: userCreatedFlag }
}

export function confirmNewReservationFailedAction(): IConfirmNewReservationFailedAction {
  return { type: ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION_FAILED }
}